
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.971 10a9.307 9.307 0 01-2.075 2.5M12 14.5v2m0-2c1.131 0 2.126-.16 3-.43m-3 .43a10.09 10.09 0 01-3-.43m6 0L16 16m-1-1.93a8.31 8.31 0 002.896-1.57m0 0l1.604 1.57m-10.5 0L8 16m1-1.93c-2.581-.799-4.105-2.569-4.971-4.07m2.075 2.5L4.5 14","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    